(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("itowns_lasparser", [], factory);
	else if(typeof exports === 'object')
		exports["itowns_lasparser"] = factory();
	else
		root["itowns_lasparser"] = factory();
})(self, () => {
return 